import { Cell, flexRender, Row } from "react-table-8.10.7";
import { Registration } from "store/apis/salesTaxRegistration";

type MobileRegistrationRowProps = {
  row: Row<Registration>;
  onClick: (registration: Registration) => void;
};

// Column ids set on the column helpers in SalesTaxRegistrations.
const REGISTRATION_COLUMN_ID = {
  STATE: "state",
  REQUESTED_ON: "request_date",
  STATUS: "status",
  ACTION: "tax_detail_id",
} as const;

const renderCell = (cell?: Cell<Registration, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileRegistrationRow = ({
  row,
  onClick,
}: MobileRegistrationRowProps) => {
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );

  const handleClick = () => onClick(row.original);

  return (
    <div
      onClick={handleClick}
      className="t-flex t-cursor-pointer t-flex-col t-gap-3 t-rounded-lg t-border t-border-solid t-border-neutral-0 t-p-3"
    >
      <div className="t-flex t-items-start t-justify-between t-gap-3">
        <span className="t-min-w-0 t-text-subtext-sm t-text-text-100">
          {renderCell(cellsById[REGISTRATION_COLUMN_ID.STATE])}
        </span>
        <div className="t-shrink-0">
          {renderCell(cellsById[REGISTRATION_COLUMN_ID.STATUS])}
        </div>
      </div>

      <div className="t-flex t-items-end t-justify-between t-gap-3">
        <div className="t-flex t-flex-col t-gap-1 t-text-body-sm">
          <span className="t-text-text-30">Requested on</span>
          <span className="t-text-text-60">
            {renderCell(cellsById[REGISTRATION_COLUMN_ID.REQUESTED_ON])}
          </span>
        </div>
        <div className="t-shrink-0">
          {renderCell(cellsById[REGISTRATION_COLUMN_ID.ACTION])}
        </div>
      </div>
    </div>
  );
};
